import ReactDOM from 'react-dom';
import { App } from './App';
import './index.css';

import reportWebVitals from './reportWebVitals';

import { createBrowserHistory } from 'history';
import {HashRouter } from "react-router-dom";
import { ConfigProvider } from './context/config';
let history = createBrowserHistory({});

ReactDOM.render(
  <>
  <ConfigProvider>
      <HashRouter>
          <App history={history}   />
      </HashRouter>
  </ConfigProvider>
  </>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals( );
